import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import React, { useEffect, useState } from 'react';

import s from './ProgressSteps.module.scss';

interface ProgressStepsProps {
  steps: string[];
  alternateStepsSeparator?: string;
  activeStep?: string;
}

const ProgressSteps = ({
  steps,
  activeStep,
  alternateStepsSeparator = '/'
}: ProgressStepsProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!activeStep) return;
    const index = steps.findIndex((step) => {
      const possibleSteps = step.split(alternateStepsSeparator);
      return possibleSteps.includes(activeStep);
    });
    if (index > -1) {
      setActiveIndex(index);
    }
  }, [steps, activeStep, alternateStepsSeparator]);

  return (
    <Box sx={{ mb: 2 }} className={s.ProgressSteps}>
      {steps.map((step, index) => (
        <LinearProgress
          sx={{ height: '6px', borderRadius: '1px', backgroundColor: 'grey.200' }}
          className={s.ProgressSteps__item}
          variant="determinate"
          key={step}
          value={index > activeIndex ? 0 : 100}
        />
      ))}
    </Box>
  );
};

export default ProgressSteps;
